// Module
var code = "<div class=\"c-definitions c-acpDisplay\">\n    <div class=\"c-definition\">\n        <div class=\"c-definition-term\" ng-bind=\"::$ctrl.localeKeys.E_WALLET.ACP.ACCOUNT_ID | i18n\"></div>\n        <div class=\"c-definition-value\" ng-bind=\"$ctrl.detailData.AccountId | invEmpty\"></div>\n    </div>\n</div>\n";
// Exports
module.exports = code;